<template>
  <div id="sticky-nav"
       class="
          uk-width-full
          uk-height-auto
          uk-position-z-index
          nav-transparent-background
        "
       :class="{
         'uk-height-1-1': submenuOpen,
         'submenu-open': submenuOpen
      }"
       uk-sticky="offset: 0px;"
  >
    <div class="uk-height-1-1" id="nav">
      <div class="uk-navbar-left uk-flex-around uk-float-left uk-margin-large-left">
        <PlayPauseIcon />
        <a href="/" class="uk-navbar-item main-nav-left-text">
          Roos Netjes
        </a>
      </div>
      <div class="uk-navbar-right uk-flex-right nav-bar-float-right uk-margin-large-right">
        <Hamburger
          class="uk-navbar-toggle uk-float-right uk-hidden@m"
          @toggle="toggleSubmenu"
        />
        <a href="https://soundcloud.com/user-478935914" target="_blank" class="uk-navbar-item uk-visible@m
        main-nav-right-text">
          Soundcloud
        </a>
        <router-link to="/over-roos" class="uk-navbar-item uk-visible@m main-nav-right-text">
          Over Roos
        </router-link>
        <router-link :to="{ path: '/', hash: '#contactForm' }" class="uk-navbar-item uk-visible@m
        main-nav-right-text">
          Contact
        </router-link>

      </div>

      <!-- Medium and down (hamburger) menu -->
      <div class="uk-animation-slide-top-medium uk-height-1-1 mobile-menu hidden@m"
           :class="{'uk-hidden': !submenuOpen}">
        <a href="https://soundcloud.com/user-478935914" target="_blank" class="uk-navbar-item">
          Soundcloud
        </a>
        <router-link to="/over-roos" class="uk-navbar-item">
          Over Roos
        </router-link>
        <router-link :to="{ path: '/', hash: '#contactForm' }" class="uk-navbar-item">
          Contact
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Hamburger from '@/components/Hamburger.vue';
import PlayPauseIcon from './PlayPauseIcon.vue';

export default {
  name: 'MainNav.vue',
  components: {
    PlayPauseIcon,
    Hamburger,
  },
  methods: {
    toggleSubmenu(isOpen) {
      this.submenuOpen = isOpen;
    },
  },
  data() {
    return {
      submenuOpen: false,
    };
  },
};
</script>
